import React, { Component } from 'react';

//import indexCard from './../../assets/img/index-card.png';
import './../../assets/css/footer.css';
import { loadYTPlayer } from './../../tools/ytPlayer.js';

class Footer extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    loadYTPlayer();
  }

  render() {
    return (
      <footer className="App-footer">
        <div class="footer__pane pane__video">
          <div id="playerContainer"><div id="player"></div></div>
        </div>
        <div class="footer__pane pane__links">
          <p>
            A generator by <a href="http://hexed.press">Hexed Press</a>.
            Support the generator via <a href="https://www.patreon.com/hexedpress">Patreon</a>.
          </p>
          <p>
            Find me on <a href="https://twitter.com/hexedpressman">twitter</a> and <a href="https://www.reddit.com/r/hexedpress/">reddit</a>.
          </p>
        </div>
      </footer>
    );
  }
}

export default Footer;


// WEBPACK FOOTER //
// ./src/components/ui/footer.jsx